import React, { PureComponent } from 'react';
import cloneDeep from 'lodash.clonedeep';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import ReactEcharts from './ReactEcharts';

dayjs.extend(LocalizedFormat)

export default class RichScatterPlot extends PureComponent {
  constructor(props) {
    super(props)
    this.itemStyle = {
      normal: {
        borderWidth: 1,
        borderColor: '#777',
        opacity: 0.3,
      },
      emphasis: {
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: 'rgba(0,0,0,0.5)'
      }
    };

    this.state = this.getInitialState();
  }
  getInitialState = () => ({option: this.getOption()});

  componentWillReceiveProps(nextProps) {
    if (nextProps.data === this.props.data)
      return;
    this.updateChart(nextProps)
  }

  getOption = () => ({
    color: ['#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9',
      '#bc80bd', '#ccebc5', '#8dd3c7', '#ffffbc', '#bebada', '#ffed6f'],
    tooltip: {
      formatter: function (d) {
        return `${d.value[3].toUpperCase()}<br>` +
          `Release date : ${dayjs(d.value[0]).format('ll')}<br>` +
          `Resolution : ${d.value[1]}Å<br>` +
          `Number of grid points : ${d.value[2][0]}×${d.value[2][1]}×${d.value[2][2]}<br>`;
      }
    },
    dataZoom: {
      type: 'inside',
    },
    grid: {
      top: 10,
      bottom: 40,
      left: 40,
      right: 20
    },
    xAxis: {
      type: 'time',
      nameGap: 16,
      splitLine: {
        show: false
      },
    },
    yAxis: {
      type: 'log',
      nameLocation: 'end',
      nameGap: 20,
      splitLine: {
        show: false
      }
    },
    series: []
  });

  updateChart = (props) => {
    let {sizeFactor} = props;
    if(!sizeFactor) sizeFactor = 1;
    let {schema, data, tooltipSide} = props;
    const option = cloneDeep(this.state.option); // immutable

    let itemCount = [0, ...data].reduce((a,b) => a+b.data.length);
    this.itemStyle.normal.opacity = 1000 / itemCount;
    if(this.itemStyle.normal.opacity > 0.5)
      this.itemStyle.normal.opacity = 0.5;

    option.grid = {
      top: 10 * sizeFactor,
      bottom: 40 * sizeFactor,
      left: 40 * sizeFactor,
      right: 20 * sizeFactor
    };

    //option.xAxis.name = schema[0].text;
    option.xAxis.axisLabel = {fontSize: 12 * sizeFactor};
    option.yAxis.name = schema[1].text;
    option.yAxis.axisLabel = {fontSize: 12 * sizeFactor};
    option.series = data.map(d => ({
      name: d.name,
      type: 'scatter',
      symbolSize: function (data) {
          return Math.max(Math.sqrt(data[2][0]) * 0.5, 5) * sizeFactor;
      },
      itemStyle: this.itemStyle,
      data: d.data
    }));
    if(tooltipSide)
      option.tooltip.position = (point, params, dom, rect, size) => [point[0] + 10, point[1] - size.contentSize[1] - 20]

    this.setState({
      option,
    });
  };

  onChartClick(params) {
    if(params.componentType !== 'series')
      return;
    if(this.props.onSelected)
      this.props.onSelected(params.data[4])
  }

  render() {
    let onEvents = {
      'click': this.onChartClick.bind(this),
    }
    return (
      <ReactEcharts
        option={this.state.option}
        style={{height: this.props.height, width: this.props.width}}
        onEvents={onEvents}
        className='react_for_echarts' />
    );
  }
}
